export default __webpack_public_path__ + "static/media/linux.d816c02b.png";